import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import CopyCitationReferenceEditing from './copycitationreferenceediting';

export default class CopyCitationReference extends Plugin {
  static get requires() {
    return [ CopyCitationReferenceEditing ];
  }

  static get pluginName() {
    return 'CopyCitationReference';
  }
}
